import React from 'react';
import ServiceCard from './ServiceCard';

const ServicesSection = ({ services, onServiceSelect, activeTab }) => {
  
  // Services are already filtered and sorted in Main.jsx
  const filteredServices = services;

  // Single render method for all service types
  return (
    <section className="services-section">
      <div className="services-grid">
        {filteredServices.map((service) => (
          <ServiceCard 
            key={service._id || service.id} 
            service={service} 
            onServiceSelect={onServiceSelect} 
          />
        ))}
      </div>
    </section>
  );
};

export default ServicesSection;